(() => {
  const fixKachingBundle = () => {
    document.querySelectorAll('.kaching-bundles__bar-subtitle').forEach((element) => {
      const current = element.textContent || '';
      const corrected = current.replace(/pièces/gi, (word) => word === word.toUpperCase() ? 'TABLETTES' : word[0] === word[0].toUpperCase() ? 'Tablettes' : 'tablettes');
      if (corrected !== current) {
        for (const node of element.childNodes) {
          if (node.nodeType === 3 && /pièces/i.test(node.nodeValue || '')) {
            node.nodeValue = (node.nodeValue || '').replace(/pièces/gi, (word) => word === word.toUpperCase() ? 'TABLETTES' : word[0] === word[0].toUpperCase() ? 'Tablettes' : 'tablettes');
          }
        }
      }
    });
    document.querySelectorAll('[data-a11y-label="system.price"]').forEach((element) => element.setAttribute('data-a11y-label', 'Prix'));
    document.querySelectorAll('[data-a11y-label="system.original_price"]').forEach((element) => element.setAttribute('data-a11y-label', "Prix d'origine"));
  };
  const start = () => {
    fixKachingBundle();
    const observer = new MutationObserver(fixKachingBundle);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();